import { UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  ConfigProvider,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Tag,
  Upload,
} from "antd";
import Modal from "antd/es/modal/Modal";
import axios from "axios";
import style from "css/menu.module.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import ResEndpointSideBox from "../menu/resEndpointSideBox";
import ResParticipantSideBox from "../menu/resParticipantSideBox";

export default function ResPop({
  isOpenRes,
  close,
  makenew,
  setSchedule,
  schedule,
  getScheduleList,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const meetingTimePayload = useSelector((state) => state.meetingTime);
  const [form] = Form.useForm();

  const [isMore, setIsMore] = useState(false);
  const [isPasswordEnabled, setIsPasswordEnabled] = useState(false);

  const [inputMemberList, setInputMemberList] = useState([]);

  const [treeMemberList, setTreeMemberList] = useState([]);
  const [searchMemberList, setSearchMemberList] = useState([]);
  const [recentMemberList, setRecentMemberList] = useState([]);

  const [isOpenParticpantSideBox, setIsOpenParticpantSideBox] = useState(false);
  const [isOpenEndpointSideBox, setIsOpenEndpointSideBox] = useState(false);

  const [searchEndpointList, setSearchEndpointList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [preSchedule, setPreSchedule] = useState("");
  const [fileList, setFileList] = useState([]);

  const [vcType, setVcType] = useState("");

  useEffect(() => {
    setPreSchedule(schedule);
    getSystemType();

    setFileList(
      (schedule.ATTACHMENT_LIST || []).map((attachment) => ({
        uid: attachment.FILE_ID,
        name: attachment.ORI_FILE_NM,
        status: "success",
        url: attachment.FILE_URL,
      }))
    );
  }, [isOpenRes]);

  useEffect(() => {
    setIsPasswordEnabled(schedule.MEETING_PW !== "" ? true : false);
  }, [isOpenRes]);

  const getSystemType = () => {
    axios
      .get("/schedule/systemInfo")
      .then((res) => {
        if (res.status === 200) {
          setVcType(res.data.SYSTEM_TYPE);
          setSchedule((pre) => ({
            ...pre,
            SYSTEM_TYPE: res.data.SYSTEM_TYPE,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSchedule((schedule) => ({ ...schedule, [name]: value }));
  };

  const pwOptionChange = (e) => {
    if (isPasswordEnabled) {
      setSchedule((pre) => ({
        ...pre,
        MEETING_PW: "",
      }));
    }

    setIsPasswordEnabled(e.target.checked);
  };

  const scheduleTypeChange = (e) => {
    const vcYn = e.target.value;

    setSchedule((pre) => ({
      ...pre,
      SCHEDULE_TYPE: vcYn === "Y" ? vcType : "CD0205",
    }));

    if (vcYn !== "Y") {
      setSchedule((pre) => ({
        ...pre,
        ENDPOINT_LIST: preSchedule.ENDPOINT_LIST,
      }));
    }
  };

  const participantChange = (p) => {
    setSchedule((pre) => {
      const filteredList = pre.PARTICIPANT_LIST.filter((item) => {
        return p.MEMBER_ID !== item.MEMBER_ID;
      });

      if (p.isChecked) {
        filteredList.push(p);
      }

      return { ...pre, PARTICIPANT_LIST: filteredList };
    });
  };

  const participantDeselect = (pId) => {
    setSchedule((pre) => {
      const filteredList = pre.PARTICIPANT_LIST.filter((item) => {
        return pId !== item.MEMBER_ID;
      });

      return { ...pre, PARTICIPANT_LIST: filteredList };
    });

    setSearchMemberList(
      searchMemberList.map((m) =>
        m.MEMBER_ID === pId ? { ...m, isChecked: !m.isChecked } : m
      )
    );

    setRecentMemberList(
      recentMemberList.map((m) =>
        m.MEMBER_ID === pId ? { ...m, isChecked: !m.isChecked } : m
      )
    );
  };

  // default participant input
  const handleInputMemberCheck = (memberIdArr) => {
    let memberId = memberIdArr[memberIdArr.length - 1];

    if (inputMemberList.length === 1) {
      memberId = inputMemberList[0].MEMBER_ID;
    }

    if (Array.isArray(memberIdArr) && memberIdArr.length > 0) {
      const params = { MEMBER_ID: memberId };

      // const url = "/address/detail";
      // let config = {
      //   params: {
      //     MEMBER_ID: memberId,
      //   },
      // };
      axios
        // .get(url, config)
        .post("/user/detail", params)
        .then((res) => {
          if (res.status === 200) {
            let inputSearchMember = {};
            if (res.data !== "") {
              inputSearchMember = res.data;
              inputSearchMember.isChecked = !inputSearchMember.isChecked;
              participantChange(inputSearchMember);
            } else {
              const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

              if (regex.test(memberId)) {
                inputSearchMember.MEMBER_ID = memberId;
                inputSearchMember.MEMBER_NM = memberId;
                inputSearchMember.EMAIL = memberId;
                inputSearchMember.isChecked = !inputSearchMember.isChecked;
                participantChange(inputSearchMember);
              } else {
                const obj = {
                  title: "알림",
                  content: "이메일형식오류입니다.",
                  submitEventHandler: () => {
                    dispatch(closeAlert());
                  },
                };
                dispatch(openAlert(obj));
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  // (input Member)
  const handleInputMember = (value) => {
    if (value) {
      inputMembers(value);
    } else {
      setInputMemberList([]);
    }
  };
  // searched input MemberList
  const inputMembers = (value) => {
    // const url = "/user/searchList";
    const url = "/address/searchList";
    let config = {
      params: {
        KEY_WORD: value,
      },
    };
    axios
      .get(url, config)
      .then((res) => {
        if (res.status === 200) {
          setInputMemberList(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const endpointDeselect = (eId) => {
    setSchedule((pre) => {
      const filteredList = pre.ENDPOINT_LIST.filter((item) => {
        return !eId.includes(item.ENDPOINT_ID);
      });

      return { ...pre, ENDPOINT_LIST: filteredList };
    });

    setSearchEndpointList(
      searchEndpointList.map((e) =>
        e.ENDPOINT_ID === eId ? { ...e, isChecked: !e.isChecked } : e
      )
    );
  };

  const toggleParticipantSideBox = () => {
    setIsOpenEndpointSideBox(false);
    setIsOpenParticpantSideBox(!isOpenParticpantSideBox);
  };

  const toggleEndpointBox = (e) => {
    if (
      schedule.SCHEDULE_TYPE === "CD0205" &&
      schedule.ENDPOINT_LIST.length === 1
    ) {
      setIsOpenParticpantSideBox(false);
      setIsOpenEndpointSideBox(false);
    } else {
      setIsOpenParticpantSideBox(false);
      setIsOpenEndpointSideBox(true);
    }
  };

  const closeParticipantSideBox = () => {
    setIsOpenParticpantSideBox(false);
  };

  const closeEndpointSideBox = () => {
    setIsOpenEndpointSideBox(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let params = {
      PROCESS_TYPE: schedule.PROCESS_TYPE,
      SCHEDULE_ID: schedule.SCHEDULE_ID,
      // SCHEDULE_TYPE: schedule.SCHEDULE_TYPE,
      SCHEDULE_TYPE: "CD0203",
      TITLE: schedule.TITLE,
      CONTENTS: schedule.CONTENTS,
      FILE_INFO: schedule.FILE_INFO,
      OPEN_YN: schedule.OPEN_YN,
      RECORD_YN: schedule.RECORD_YN,
      MAIL_YN: schedule.MAIL_YN,
      MEETING_PW: schedule.MEETING_PW,
      PARTICIPANT_LIST: schedule.PARTICIPANT_LIST,
      ENDPOINT_LIST: schedule.ENDPOINT_LIST,
      ATTACHMENT_LIST: fileList,
      CHANGED: {},
    };

    if (schedule.PROCESS_TYPE === "U") {
      params.FAVORITES_ID = schedule.FAVORITES_ID;

      changed.sort();
      let data = changed.join(",");
      params.CHANGED = data;
    }

    if (!confirmVal(params)) {
      return;
    }

    const formData = new FormData();
    formData.append("params", JSON.stringify(params));

    fileList.forEach((file) => {
      formData.append("files", file);
    });

    setLoading(true);
    if (schedule.PROCESS_TYPE === "C") {
      axios
        .post("/schedule/favorite", formData)
        .then((res) => {
          if (res.status === 200) {
            const obj = {
              title: t("MESSAGE.NOTIFICATION"),
              content: t("MESSAGE.REGISTER_COMPLETE"),
              submitEventHandler: () => {
                getScheduleList();
                dispatch(closeAlert());
              },
            };
            dispatch(openAlert(obj));
            setLoading(false);
            closePop();
          }
        })
        .catch((error) => {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: error.response.data,
            submitEventHandler: () => {
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          setLoading(false);
        });
    } else {
      axios
        .put("/schedule/favorite", formData)
        .then((res) => {
          if (res.status === 200) {
            const obj = {
              title: t("MESSAGE.NOTIFICATION"),
              content: t("MESSAGE.MODIFY_COMPLETE"),
              submitEventHandler: () => {
                getScheduleList();
                dispatch(closeAlert());
              },
            };
            dispatch(openAlert(obj));
            setLoading(false);
            closePop();
          }
        })
        .catch((error) => {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: error.response.data,
            submitEventHandler: () => {
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          setLoading(false);
        });
    }
  };

  const deletefavorite = () => {
    let params = {
      FAVORITES_ID: schedule.FAVORITES_ID,
    };
    axios
      .put("/schedule/deletefavorite", params)
      .then((res) => {
        if (res.status === 200) {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.DELETE_COMPLETE"),
            submitEventHandler: () => {
              getScheduleList();
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          setLoading(false);
          closePop();
        }
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };

  const confirmVal = (schedule) => {
    let isCorrect = true;

    if (schedule.TITLE === undefined || schedule.TITLE.trim().length === 0) {
      const obj = {
        title: t("MESSAGE.NOTIFICATION"),
        content: t("MESSAGE.TITLE_ERROR"),
        submitEventHandler: () => {
          dispatch(closeAlert());
        },
      };
      dispatch(openAlert(obj));

      isCorrect = false;
      return isCorrect;
    }

    if (isPasswordEnabled) {
      if (schedule.MEETING_PW.length < 4 || schedule.MEETING_PW.length > 20) {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.MEETING_PW_ALERT"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
        return;
      }
    }

    return isCorrect;
  };

  const closePop = () => {
    setIsMore(false);
    setIsPasswordEnabled(false);
    setIsOpenParticpantSideBox(false);
    // handleSearchMember("");
    setIsOpenEndpointSideBox(false);
    setSearchEndpointList([]);
    // setEndpointDeptList([]);
    setSchedule({});
    setghostrun(true);
    setchanged([]);
    close();
  };

  const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  const [ghostdata, setghostdata] = useState([]);
  const [ghostrun, setghostrun] = useState(true);
  useEffect(() => {
    if (
      schedule.SCHEDULE_ID !== "" &&
      schedule.SCHEDULE_ID !== undefined &&
      schedule.PROCESS_TYPE === "U"
    ) {
      if (ghostrun) {
        setghostdata(schedule);
        setchanged([]);
        setghostrun(false);
      }
    }
  }, [ghostrun, ghostdata, schedule]);
  const [check, setcheck] = useState(false);
  const [changed, setchanged] = useState([]);

  const listcheck = (val1, val2, type) => {
    if (
      schedule.PROCESS_TYPE === "U" &&
      val1 !== undefined &&
      val2 !== undefined
    ) {
      if (type === "PARTICIPANT") {
        for (var i = 0; i < val1.length; i++) {
          let flag = false;
          for (var k = 0; k < val2.length; k++) {
            if (val1[i].MEMBER_ID === val2[k].MEMBER_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        for (var j = 0; j < val2.length; j++) {
          let flag = false;
          for (var q = 0; q < val1.length; q++) {
            if (val1[q].MEMBER_ID === val2[j].MEMBER_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        return true;
      } else if (type === "ENDPOINT") {
        for (var z = 0; z < val1.length; z++) {
          let flag = false;
          for (var x = 0; x < val2.length; x++) {
            if (val1[z].ENDPOINT_ID === val2[x].ENDPOINT_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        for (var c = 0; c < val2.length; c++) {
          let flag = false;
          for (var v = 0; v < val1.length; v++) {
            if (val1[v].ENDPOINT_ID === val2[c].ENDPOINT_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        return true;
      }
    }
  };

  useEffect(() => {
    let flags = false;
    if (ghostdata.TITLE !== schedule.TITLE) {
      if (!changed.includes("회의 명")) {
        setchanged(changed.concat("회의 명"));
      }
      flags = true;
    } else {
      if (changed.includes("회의 명")) {
        setchanged(changed.filter((data) => data !== "회의 명"));
      }
    }
    if (ghostdata.CONTENTS !== schedule.CONTENTS) {
      flags = true;
      if (!changed.includes("회의 내용")) {
        setchanged(changed.concat("회의 내용"));
      }
    } else {
      if (changed.includes("회의 내용")) {
        setchanged(changed.filter((data) => data !== "회의 내용"));
      }
    }

    if (
      ghostdata.PARTICIPANT_LIST !== undefined &&
      schedule.PARTICIPANT_LIST !== undefined
    ) {
      if (
        !listcheck(
          ghostdata.PARTICIPANT_LIST,
          schedule.PARTICIPANT_LIST,
          "PARTICIPANT"
        )
      ) {
        flags = true;
        if (!changed.includes("참석자")) {
          setchanged(changed.concat("참석자"));
        }
      } else {
        if (changed.includes("참석자")) {
          setchanged(changed.filter((data) => data !== "참석자"));
        }
      }
    }

    if (
      ghostdata.ENDPOINT_LIST !== undefined &&
      schedule.ENDPOINT_LIST !== undefined
    ) {
      if (
        !listcheck(ghostdata.ENDPOINT_LIST, schedule.ENDPOINT_LIST, "ENDPOINT")
      ) {
        flags = true;
        if (!changed.includes("회의실")) {
          setchanged(changed.concat("회의실"));
        }
      } else {
        if (changed.includes("ENDPOINT")) {
          setchanged(changed.filter((data) => data !== "회의실"));
        }
      }
    }
    let optionboolean = false;
    if (ghostdata.MAIL_YN !== schedule.MAIL_YN) {
      flags = true;
      optionboolean = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (ghostdata.MEETING_PW !== schedule.MEETING_PW) {
      optionboolean = true;
      flags = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (ghostdata.RECORD_YN !== schedule.RECORD_YN) {
      optionboolean = true;
      flags = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (ghostdata.OPEN_YN !== schedule.OPEN_YN) {
      optionboolean = true;
      flags = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (flags) {
      setcheck(true);
    } else {
      setcheck(false);
      setchanged([]);
    }
  }, [schedule]);

  // useEffect(() => {
  //   // 데이터 변경 감지 로직
  //   const detectChanges = (pre, current) => {
  //     if (pre && current) {
  //       let changeCnt = 0;
  //       const keys = Object.keys(pre);

  //       for (let i = 0; i < keys.length; i++) {
  //         const key = keys[i];
  //         if (Array.isArray(pre[key]) && Array.isArray(current[key])) {
  //           // 데이터가 배열인 경우
  //           let isSameMembers = true;
  //           let isSameEndpoints = true;

  //           if(key === "PARTICIPANT_LIST"){
  //             if(pre[key].length === current[key].length) {
  //               const memberIdsA = pre[key].map(obj => obj.MEMBER_ID).sort();
  //               const memberIdsB = current[key].map(obj => obj.MEMBER_ID).sort();

  //               for (let i = 0; i < memberIdsA.length; i++) {
  //                 if (memberIdsA[i] !== memberIdsB[i]) {
  //                   isSameMembers = false;
  //                   changeCnt++;
  //                   break;
  //                 }
  //               }
  //             } else {
  //               isSameMembers = false;
  //               changeCnt++;
  //             }
  //           }

  //           if(key === "ENDPOINT_LIST"){
  //             if(pre[key].length === current[key].length) {
  //               const endpointIdsA = pre[key].map(obj => obj.ENDPOINT_ID).sort();
  //               const endpointIdsB = current[key].map(obj => obj.ENDPOINT_ID).sort();

  //               for (let i = 0; i < endpointIdsA.length; i++) {
  //                 if (endpointIdsA[i] !== endpointIdsB[i]) {
  //                   isSameEndpoints = false;
  //                   changeCnt++;
  //                   break;
  //                 }
  //               }
  //             } else {
  //               isSameEndpoints = false;
  //               changeCnt++;
  //             }
  //           }
  //         } else {
  //           // 데이터가 텍스트인 경우
  //           if (pre[key] !== current[key]) {
  //             changeCnt++;
  //           }
  //         }
  //       }

  //       if(changeCnt === 0) {
  //         console.log("데이터 변경안됨!");
  //       }
  //     };
  //   }
  //   detectChanges(preSchedule, schedule);
  // }, [schedule]);

  const tagRender = (props) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 5,
          backgroundColor: "#ededed",
          borderColor: "#ededed",
          borderRadius: "15.5px",
          padding: "4px 13px 4px 11.5px",
          color: "#121212",
          fontSize: "14px",
        }}
      >
        {label}
      </Tag>
    );
  };

  const props = {
    onRemove: (file) => {
      setFileList((prev) => {
        const index = prev.indexOf(file);
        const newFileList = prev.slice();
        newFileList.splice(index, 1);
        return newFileList;
      });
    },
    beforeUpload: (file) => {
      setFileList((prev) => [...prev, file]);
      return false;
    },
    fileList,
  };

  const makeschedule = () => {
    makenew();
  };

  const handlePreview = (file) => {
    const segments = file.url.split("/");
    const lastPart = segments[segments.length - 1];

    const params = {
      FILE_NM: lastPart,
      ORI_FILE_NM: file.name,
    };

    axios
      .post("/schedule/downloadFile", params, { responseType: "blob" })
      .then((response) => response.data)
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file.name);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };
  const systemtype = useSelector((state) => state.system.isOnline);
  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            colorTextDescription: "#fff",
          },
          Input: {
            borderRadius: "5px",
          },
          DatePicker: {
            colorInfoText: "#fff",
          },
          Radio: {
            colorBorder: "#fff",
          },
          Upload: {
            colorPrimary: "#1cb691",
            colorPrimaryHover: "#1cb691",
            colorPrimaryActive: "#1cb691",
          },
        },
      }}
    >
      <Modal
        className={style.res_popup}
        open={isOpenRes}
        closable={false}
        onCancel={closePop}
        maskClosable={false}
        footer={null}
        wrapClassName={style.res_popup_modal_wrap}
      >
        <Form form={form} onFinish={handleSubmit}>
          <Spin spinning={loading}>
            <div className={style.res_popup_wrap}>
              <div className={style.res_popup_container}>
                <div className={style.res_popup_content_contaier}>
                  <div>
                    <article className={style.res_popup_header}>
                      <p className={style.title}>
                        {schedule.PROCESS_TYPE === "U"
                          ? t("LABEL.TITLE.MODIFY_FAVORITE_MEETING")
                          : t("LABEL.TITLE.CREATE_FAVORITE_MEETING")}
                      </p>
                      <img
                        className={style.res_popup_sideBox_closeBtn}
                        src={
                          process.env.REACT_APP_CLIENT_URL +
                          "img/menu/close.png"
                        }
                        alt="close"
                        onClick={() => closePop()}
                      />
                    </article>
                    <div className={style.res_popup_body}>
                      <Form.Item style={{ marginBottom: "13px" }}>
                        <div className={style.res_popup_input_label}>
                          {t("LABEL.MEETING_TITLE")}
                        </div>
                        <Input
                          name="TITLE"
                          size="large"
                          value={schedule.TITLE ?? ""}
                          onChange={handleChange}
                          placeholder={t("PLACEHOLDER.INPUT.WRITE_TITLE")}
                          className={style.res_popup_input_value}
                        />
                      </Form.Item>

                      {systemtype === false ? (
                        ""
                      ) : (
                        <Form.Item style={{ marginBottom: "13px" }}>
                          <div className={style.res_popup_input_label}>
                            {t("LABEL.TYPE")}
                          </div>
                          <div className={style.res_popup_input_scheduleType}>
                            <div
                              className={
                                style.res_popup_input_scheduleType_label
                              }
                            >
                              {t("LABEL.VIDEO_MEETING_YN")}
                            </div>
                            <Radio.Group
                              name="VC_YN"
                              optionType="button"
                              value={
                                systemtype === false
                                  ? "N"
                                  : schedule.SCHEDULE_TYPE !== "CD0205"
                                  ? "Y"
                                  : "N"
                              }
                              className={style.res_popup_radio_group}
                              onChange={scheduleTypeChange}
                              disabled={
                                schedule.PROCESS_TYPE === "U" ? true : false
                              }
                            >
                              <Radio
                                value="Y"
                                className={style.res_popup_radio_scheduleType}
                                // disabled={schedule.SCHEDULE_TYPE !== "CD0205" ? false : true}
                              >
                                {t("common.button.yes")}
                              </Radio>
                              <Radio
                                value="N"
                                className={style.res_popup_radio_scheduleType}
                              >
                                {t("common.button.no")}
                              </Radio>
                            </Radio.Group>
                          </div>
                        </Form.Item>
                      )}

                      {/* <Form.Item style={{ marginBottom: "13px" }}>
                        <div className={style.res_popup_input_label}>장소</div>
                        <Select
                          mode="multiple"
                          name="ENDPOINT_LIST"
                          size="large"
                          className={style.res_popup_input_value}
                          placeholder="회의실을 선택해주세요"
                          value={(schedule.ENDPOINT_LIST || []).map(
                            (endpoint) => ({
                              value: endpoint.ENDPOINT_ID,
                              label: endpoint.ENDPOINT_NM,
                            })
                          )}
                          notFoundContent={null}
                          onDeselect={endpointDeselect}
                          onFocus={toggleEndpointBox}
                          filterOption={filterOption}
                          tagRender={tagRender}
                          inputValue=""
                        ></Select>
                      </Form.Item> */}
                      <Form.Item style={{ marginBottom: "26px" }}>
                        <div className={style.res_popup_input_label}>
                          {t("LABEL.MEETING_PTCP")}
                        </div>
                        <div className={style.res_popup_input_participant}>
                          <Select
                            mode="tags"
                            name="PARTICIPANT_LIST"
                            size="large"
                            className={style.res_popup_input_participant_value}
                            placeholder={t("PLACEHOLDER.INPUT.PTCP_EMAIL")}
                            value={(schedule.PARTICIPANT_LIST || []).map(
                              (participant) => ({
                                value: participant.MEMBER_ID,
                                label: participant.DISPLAY_NM,
                              })
                            )}
                            notFoundContent={null}
                            onDeselect={participantDeselect}
                            onSearch={handleInputMember}
                            onChange={handleInputMemberCheck}
                            tokenSeparators={[","]}
                            options={(inputMemberList || []).map((member) => ({
                              value: member.MEMBER_ID,
                              label: member.DISPLAY_NM,
                            }))}
                            showSearch
                            filterOption={filterOption}
                            tagRender={tagRender}
                          ></Select>
                          <Button
                            className={style.res_popup_add_btn}
                            onClick={toggleParticipantSideBox}
                          >
                            {t("BTN.ADD")}
                          </Button>
                        </div>
                      </Form.Item>
                      <Button
                        onClick={(e) => {
                          setIsMore(!isMore);
                        }}
                        className={`${style.res_popup_btn_more} ${
                          isMore ? style.open : ""
                        }`}
                      >
                        {t("BTN.MORE_OPTIONS")}
                      </Button>
                      <div
                        className={`${style.res_popup_more} ${
                          isMore ? style.open : ""
                        }`}
                      >
                        <Row gutter={16}>
                          {systemtype === false ? (
                            ""
                          ) : (
                            <Col span={12}>
                              <Form.Item style={{ marginBottom: "13px" }}>
                                <div className={style.res_popup_input_label}>
                                  {t("LABEL.VIDEO_RECORD_YN")}
                                  <Checkbox
                                    name="RECORD_YN"
                                    checked={schedule.RECORD_YN === "Y"}
                                    value="Y"
                                    className={style.res_popup_checkbox}
                                    onChange={handleChange}
                                    disabled={
                                      schedule.SCHEDULE_TYPE === "CD0205"
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("common.button.yes")}
                                  </Checkbox>
                                  <Checkbox
                                    name="RECORD_YN"
                                    checked={
                                      schedule.RECORD_YN === "N" ||
                                      schedule.RECORD_YN === undefined
                                    }
                                    value="N"
                                    onChange={handleChange}
                                    className={style.res_popup_checkbox}
                                    disabled={
                                      schedule.SCHEDULE_TYPE === "CD0205"
                                        ? true
                                        : false
                                    }
                                  >
                                    {t("common.button.no")}
                                  </Checkbox>
                                </div>
                              </Form.Item>
                            </Col>
                          )}

                          <Col span={12}>
                            <Form.Item style={{ marginBottom: "13px" }}>
                              <div className={style.res_popup_input_label}>
                                {t("LABEL.SEND_MAIL_YN")}
                                <Checkbox
                                  name="MAIL_YN"
                                  checked={
                                    schedule.MAIL_YN === "Y" ||
                                    schedule.MAIL_YN === undefined
                                  }
                                  value="Y"
                                  className={style.res_popup_checkbox}
                                  onChange={handleChange}
                                >
                                  {t("common.button.yes")}
                                </Checkbox>
                                <Checkbox
                                  name="MAIL_YN"
                                  checked={schedule.MAIL_YN === "N"}
                                  value="N"
                                  onChange={handleChange}
                                  className={style.res_popup_checkbox}
                                >
                                  {t("common.button.no")}
                                </Checkbox>
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
                        {systemtype === false ? (
                          ""
                        ) : (
                          <Form.Item style={{ marginBottom: "13px" }}>
                            <div className={style.res_popup_input_label}>
                              {t("LABEL.SET_PW_YN")}
                              <Checkbox
                                name="PW_OPTION"
                                checked={isPasswordEnabled}
                                onChange={pwOptionChange}
                                className={style.res_popup_checkbox}
                                disabled={
                                  schedule.SCHEDULE_TYPE === "CD0205"
                                    ? true
                                    : false
                                }
                              >
                                {/* 설정 */}
                              </Checkbox>
                              {/* {isPasswordEnabled &&
                              schedule.SCHEDULE_TYPE !== "CD0205" && ( */}
                              <Input.Password
                                name="MEETING_PW"
                                onChange={handleChange}
                                value={schedule.MEETING_PW ?? ""}
                                style={{
                                  width: "calc(100% - 140px)",
                                  marginLeft: "20px",
                                }}
                                disabled={
                                  !(
                                    isPasswordEnabled &&
                                    schedule.SCHEDULE_TYPE !== "CD0205"
                                  )
                                }
                              />
                              {/* )} */}
                            </div>
                          </Form.Item>
                        )}

                        {systemtype === false ? (
                          ""
                        ) : (
                          <Form.Item style={{ marginBottom: "13px" }}>
                            <div className={style.res_popup_input_label}>
                              {t("LABEL.MEETING_LIST")}
                              <Radio.Group
                                name="OPEN_YN"
                                onChange={handleChange}
                                value={schedule.OPEN_YN}
                                optionType="button"
                                buttonStyle="solid"
                              >
                                <Radio
                                  value="Y"
                                  className={style.res_popup_radio}
                                  style={{
                                    marginLeft: "20px",
                                  }}
                                >
                                  {t("BTN.PUBLIC")}
                                </Radio>
                                <Radio
                                  value="N"
                                  className={style.res_popup_radio}
                                >
                                  {t("BTN.PRIVATE")}
                                </Radio>
                              </Radio.Group>
                              <span className={style.res_popup_openYn_label}>
                                {t("MESSAGE.MEETING_LIST_NOTICE")}
                              </span>
                            </div>
                          </Form.Item>
                        )}
                        <Form.Item style={{ marginBottom: "13px" }}>
                          <div className={style.res_popup_input_label}>
                            {t("LABEL.MEMO")}
                          </div>
                          <Input.TextArea
                            rows={2}
                            name="CONTENTS"
                            value={schedule.CONTENTS ?? ""}
                            placeholder={t(
                              "PLACEHOLDER.INPUT.WRITE_CONTENT_FAV"
                            )}
                            onChange={handleChange}
                            className={style.res_popup_input_value}
                            style={{ height: "60px", padding: "11px 13px" }}
                          />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: "20px" }}>
                          <div className={style.res_popup_input_label}>
                            {t("LABEL.ATTACHMENT")}
                            <Upload
                              {...props}
                              fileList={fileList}
                              onPreview={handlePreview}
                            >
                              <Button className={style.res_popup_upload_btn}>
                                {t("BTN.ADD")}
                                <UploadOutlined />
                              </Button>
                            </Upload>
                          </div>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                {schedule.PROCESS_TYPE === "U" ? (
                  <div className={style.res_popup_btn_container}>
                    <Button
                      type="primary"
                      onClick={() => {
                        const obj = {
                          title: t("MESSAGE.NOTIFICATION"),
                          content: t("MESSAGE.DELETE_SCD"),
                          submitEventHandler: () => {
                            deletefavorite();
                            dispatch(closeAlert());
                          },
                        };
                        dispatch(openAlert(obj));
                      }}
                      className={style.favorite_delete_btn}
                      color="red"
                    >
                      {t("BTN.DELETE_MEETING")}
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleSubmit}
                      className={style.favorite_update_btn}
                    >
                      {schedule.PROCESS_TYPE === "U"
                        ? t("BTN.UPDATE_MEETING")
                        : t("BTN.CREATE_MEETING")}
                    </Button>
                    <Button
                      onClick={() => makeschedule()}
                      className={style.res_popup_save_fav_btn}
                    >
                      {t("BTN.CREATE_MEETING")}
                    </Button>
                  </div>
                ) : (
                  <div
                    className={style.res_popup_btn_container}
                    style={{ padding: "0 63px" }}
                  >
                    <Button
                      type="primary"
                      onClick={() => closePop()}
                      className={style.res_popup_close_btn}
                    >
                      {t("BTN.CANCEL")}
                    </Button>
                    <Button
                      onClick={(e) => handleSubmit(e)} //makeschedule()}
                      className={style.res_popup_save_btn}
                    >
                      {t("BTN.CREATE")}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </Spin>
          <ResParticipantSideBox
            isOpenParticpantSideBox={isOpenParticpantSideBox}
            closeParticipantSideBox={closeParticipantSideBox}
            participantChange={participantChange}
            treeMemberList={treeMemberList}
            searchMemberList={searchMemberList}
            recentMemberList={recentMemberList}
            setTreeMemberList={setTreeMemberList}
            setSearchMemberList={setSearchMemberList}
            setRecentMemberList={setRecentMemberList}
            schedule={schedule}
          />
          <ResEndpointSideBox
            isOpenEndpointSideBox={isOpenEndpointSideBox}
            closeEndpointSideBox={closeEndpointSideBox}
            searchEndpointList={searchEndpointList}
            setSearchEndpointList={setSearchEndpointList}
            schedule={schedule}
            setSchedule={setSchedule}
          />
        </Form>
      </Modal>
    </ConfigProvider>
  );
}
